// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/bop-go/riconciliazione?societaId=1&anno=2026&mese_da=1&mese_a=8',
    requestBody: null,
    response: '{"success":true,"stato":"OK","data":{"database":"arc_solu","periodo":{"descrizione":"gen–ago 2026"},"ricavi":{"verso_conto_economico":{"partenza":{"voce":"Vendita clienti (fatture di vendita)","importo":2205408.12},"passi":[{"voce":"Quote di competenza del periodo","importo":103174.31}],"arrivo":{"voce":"Conto economico (ricavi, con competenze)","importo":2429204.89},"quadratura":0},"verso_commesse":{},"integrati":146192.16},"costi":{}}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
